// Module
var code = "<style>:host{display:block}#date{height:100%;width:100%}</style> <div id=\"date\"></div>";
// Exports
export default code;